import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { PATH } from '@old/data/core/paths';
import { useGlobalStore } from '@old/global-store/use-store';
import { getSessionSummaryService } from '@old/services/domain/auth/session-summary';
import { Box, CircularProgress } from '@mui/material';
import { LoadingBox } from '@old/styles/generic-styles';

// This page handles OAuth callback results.
// Expected query params: token, refresh_token
export const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {
    setAccessToken,
    setRefreshToken,
    setPermissions,
    setOrganizationId,
    setUserOrganizationId,
    setWasTutorialShow,
    setWas_agrotoken_integration_popup_shown,
    setWas_lasegunda_integration_popup_shown,
    setWas_warrant_popup_shown,
    setWas_rus_popup_shown,
    setUserFullname,
    setUserID,
    setEmail,
    setOrganizationTaxId,
    setOrganizationName,
    setSelectedOrganizationName,
    setAwsTempCredentials,
    setLanguage,
    setCountryId,
    setCorvusIntegrated,
    setUserPhoto,
  } = useGlobalStore();

  useEffect(() => {
    const accessToken = searchParams.get('token');
    const refreshToken = searchParams.get('refresh_token');
    const photo = searchParams.get('photo');

    if (!accessToken || !refreshToken) {
      navigate(`${PATH.ERROR}?message=${encodeURIComponent('Missing OAuth tokens')}`);
      return;
    }

    const getLoginData = async () => {
      try {
        setAccessToken(accessToken);
        setRefreshToken(refreshToken);

        if (photo) {
          setUserPhoto(photo); // ← GUARDA LA FOTO
        }

        const { summary } = await getSessionSummaryService();

        const preferedLanguageId = summary?.prefered_language_id === 1 ? 'es' : 'pt';
        localStorage.setItem('LANGUAGE_PREFERENCE', preferedLanguageId);
        setLanguage(preferedLanguageId);
        setPermissions(summary?.permissions);
        setOrganizationId(summary?.permissions?.organization?.id);
        setUserOrganizationId(summary?.permissions?.organization?.id);
        setWasTutorialShow(summary?.was_tutorial_shown);
        setWas_agrotoken_integration_popup_shown(summary?.was_agrotoken_integration_popup_shown);
        setWas_lasegunda_integration_popup_shown(summary?.was_la_segunda_popup_shown);
        setWas_warrant_popup_shown(summary?.was_warrant_popup_shown);
        setWas_rus_popup_shown(summary?.was_rus_popup_shown);
        setUserFullname(summary.userFullname);
        setUserID(summary?.userID);
        setEmail(summary?.email);
        setOrganizationTaxId(summary.organizationTaxId);
        setOrganizationName(summary.organizationName);
        setSelectedOrganizationName(summary.organizationName);
        if (summary.awsTempCredentials) setAwsTempCredentials(summary.awsTempCredentials);
        setCountryId(summary?.country_id);
        setCorvusIntegrated(summary?.corvusIntegration);

        const savedReturnUrl = localStorage.getItem('googleAuthReturnUrl');
        if (savedReturnUrl) {
          localStorage.removeItem('googleAuthReturnUrl');
          navigate(savedReturnUrl);
        } else {
          navigate(PATH.DASHBOARD);
        }
      } catch {
        navigate(`${PATH.ERROR}?message=${encodeURIComponent('OAuth session finalization failed')}`);
      }
    };

    getLoginData();
  }, []);

  return (
    <Box sx={LoadingBox}>
      <CircularProgress />
    </Box>
  );
};
